// filepath: client/src/routes/loaders/programDashboardLoader.js
import { queryClient } from '#client/utils/queryClient.js';
import { getProgramsQueryOptions, getProgramStatsQueryOptions } from '#client/utils/queryOptions/index.js';
import { isCustomer } from '#client/utils/helpers/services.js';
import { useProgramDashboardUIStore } from '#client/stores/program';
import { SHARED_CONSTANTS } from '#shared/sharedConstants.js';

/**
 * Loader for Program Management Dashboard route
 * Prefetches programs list using persisted UI state (filters, sort, page) from sessionStorage
 * This ensures the loader fetches the same data that the component will display
 */
export async function programDashboardLoader() {
    const { isCustomerUser } = isCustomer();

    // Read persisted UI state from Zustand store (sessionStorage)
    const uiState = useProgramDashboardUIStore.getState();

    // Build filters object from persisted state
    const statusVal = Array.isArray(uiState.status) && uiState.status.length > 0 ? uiState.status[0] : undefined;
    const filters = {
        status: statusVal,
        customer: uiState.customer || undefined,
        dateCreated: uiState.dateCreated || undefined,
        queryValue: uiState.queryValue || undefined,
    };

    // Parse sort from persisted sortSelected
    const [sortKey, sortDir] = (uiState.sortSelected[0] || 'createdAt desc').split(' ');
    const sortBy = sortKey || 'createdAt';
    const sortDirection = sortDir || 'desc';

    // Use persisted currentPage
    const currentPage = uiState.currentPage || 1;

    const queries = [
        queryClient.ensureQueryData(getProgramsQueryOptions(filters, sortBy, sortDirection, currentPage, SHARED_CONSTANTS.MAX_PROGRAMS_PER_PAGE)),
        !isCustomerUser && queryClient.ensureQueryData(getProgramStatsQueryOptions()),
    ].filter(Boolean);

    await Promise.all(queries);

    return null;
}
